import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import { NavLink } from 'react-router-dom';

export const Nav = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.04);
`

export const ContentWrapper = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  @media screen and (min-width: 768px) {
    padding: 8px 40px;
  }
  @media screen and (min-width: 992px) {
    padding: 20px 40px;
  }
`

export const PageTitle = styled.div`
  font-family: Manrope, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #4f4f4f;
  @media screen and (min-width: 992px) {
    font-size: 24px;
    line-height: 36px;
    padding-left: 20px;
    margin-top: 10px;
  }
`

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-start;
  flex-direction: column;
  @media screen and (min-width: 992px){
    flex-direction: row;
  }
`

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-end;
`

export const NavbarLink = styled(NavLink)`
  margin-right: 30px;
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px ;
  line-height: 180% ;
  color: #4F5388;
  &:hover{
    color: #4F5388;
    text-decoration: none;
  }
`

export const SignInBtn = styled(Button)`
  width: 124px;
  height: 48px;
  background-color: #80ABED;
  box-sizing: border-box;
  border-radius: 8px ;
  display: flex ;
  justify-content: center;
  align-items: center;
  border: none;
  @media screen and (max-width: 575px) {
    margin-left: 24px;
    margin-top: 10px;
  }
`

export const LogoLink = styled(NavLink)`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 800;
  text-align: center;
  color: #1C62EF;
  line-height: 50px;
  font-size: 28px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  & img.LogoResults {
    width: 34px;
    height: 30px;
    margin-right: 5px;
  }
  &:hover{
    color: #1C62EF;
    text-decoration: none;
  }
  @media screen and (min-width: 1440px) {
    font-size: 42px;
    & img.LogoResults {
      width: 50px;
      height: 45px;
    }
  }
`;

export const LogoText = styled.span`
  padding-left: 10px;
`

export const DropWrapper = styled.div`
  margin-left: 10px;
  position: relative;
`

export const Menu = styled.ul`
  display: none;
  position: absolute;
  top: 25px;
  right: 0;
  list-style-type: none;
  background: #fff;
  padding: 0 0 10px;
  z-index: 1;
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  border-radius: 4px;
  width: 166px;
  & a{
    margin-right: 0;
  }
  &.open{
    display: block;
  }
`

export const MenuItem = styled.li`
  color: #2C2B48;
  border-bottom: 1px solid rgba(33, 33, 33, 0.08);
  display: block;
  padding: 12px 16px 14px 8px;
  &:hover{
    color: #2C2B48;
  }
`

export const StyledImg = styled.img`
  cursor: pointer;
`;